// extracted by mini-css-extract-plugin
export default {"button":"_3wPo","focus":"_1jpZ","iconContainer":"Xktg","icon":"_1I0a","open":"RWO_","body":"_3xnW"};